import { Filter, useAggregateContexts } from '@ilteducation/content-search';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useAreas } from '@ilteducation/content-ref-data';

export default () => {
  const aggregationContextStore = useAggregateContexts('Video');
  const { aggregate, createAggrId } = aggregationContextStore;

  const { context, isLoading } = storeToRefs(aggregationContextStore);

  const aggrParams: [string[], Filter] = [['orderedAreas.id'], {}];
  const aggrId = createAggrId(...aggrParams);
  const areaAggregationResult = computed(() => context.value(aggrId));

  if (!areaAggregationResult.value && !isLoading.value(aggrId)) {
    aggregate(...aggrParams);
  }

  const { areas } = useAreas();

  const areasWithVideos = computed(() =>
    areas.value.filter((area) =>
      areaAggregationResult.value?.aggregation
        .find((aggr) => aggr.field === 'orderedAreas.id')
        ?.counts.find((count) => count.key === area.id && count.count >= 1),
    ),
  );
  const isLoadingAreasCount = computed(() => isLoading.value(aggrId));

  return {
    areasWithVideos,
    isLoading: isLoadingAreasCount,
  };
};
